import React from "react"
import styled from "styled-components"
import useReveal from "hooks/useReveal"
import SocialLinks from "../common/SocialLinks"
import { PageWidth, Eyebrow } from "components/common/Section"

const Container = styled(PageWidth)`
  border-top: 1px solid ${p => p.theme.border};
  padding: 64px 0 28px;
`
const Contact = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 64px;
  h2 {
    font-size: clamp(38px, 5vw, 60px);
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.05em;
    margin-top: 18px;
  }
`
const Signoff = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  border-top: 1px solid ${p => p.theme.border};
  padding-top: 24px;
  font-size: 11px;
  color: ${p => p.theme.muted};
  a {
    text-decoration: none;
  }
`
const ContactLink = styled.a`
  display: inline-flex; align-items: center; gap: 12px;
  margin-top: 18px; text-decoration: none;
  color: ${p => p.theme.colors.accent.primary[500]};
  span { display: inline-block; transition: transform 350ms cubic-bezier(.22,1,.36,1); }
  &:hover span, &:focus-visible span { transform: translate(3px, -3px); }
  &:active { opacity: .7; }
`
const Footer = () => {
  const ref = useReveal()
  return (
  <Container as="footer" ref={ref}>
    <Contact>
      <div>
        <Eyebrow>You’ve reached the end.</Eyebrow>
        <h2>
          Let’s build something good.
        </h2>
        <ContactLink href="https://www.linkedin.com/in/chaitanyadeorukhkar/" target="_blank" rel="noopener noreferrer" aria-label="Get in touch on LinkedIn (opens in a new tab)">
          Get in touch <span aria-hidden="true">↗</span>
        </ContactLink>
      </div>
      <SocialLinks size="17px" />
    </Contact>
    <Signoff>
      <span>Chaitanya Deorukhkar</span>
      <a href="#main-content">Back to top ↑</a>
    </Signoff>
  </Container>
)
}
export default Footer

